module.exports = __webpack_public_path__ + "img/icn-vietnamese.88a15471.svg";